import { formatSearchQuery } from '@theme/utilities';

/**
 * Applies prefix wildcard matching to search form submissions.
 * @param {HTMLFormElement} form - A search form element
 */
function enhanceSearchForm(form) {
  form.addEventListener('submit', () => {
    const input = form.querySelector('input[name="q"]');

    if (!(input instanceof HTMLInputElement)) return;

    const formatted = formatSearchQuery(input.value);

    if (formatted) {
      input.value = formatted;
    }
  });
}

for (const form of document.querySelectorAll('form[action*="/search"]')) {
  if (form instanceof HTMLFormElement) {
    enhanceSearchForm(form);
  }
}
